
export class ValidateParquetPartitionedIngestNodePathRequest {
    parquet_partitioned_path: string;

    constructor(parquet_partitioned_path: string) {
      this.parquet_partitioned_path = parquet_partitioned_path;
    }
}